module.exports = __webpack_public_path__ + "img/tube8.3b28d61.png";